// LICENSE_CODE ZON
'use strict';

/*jslint node:true, react:true*/
import etask from 'zetask';
import www_util from 'hola_pub_util';
import zutil from 'zutil';
import zurl from 'zurl';
import hopt from 'hola_opt';
import _ from 'zutil';
import be from '../be.js';
import iutil from '../install_util.js';
import ga from '../ga.js';
import { start_install } from './install_util';
import membership from '/svc/account/pub/membership.js';
import version_util from '/util/version_util.js';
var assign = Object.assign;
var cs_ping = delay => {
  return www_util.msg_post_recv({
    timeout: 2000,
    msg: {
      src: 'hola_ccgi',
      id: 'cs_ping'
    }
  });
};
var bext_log = () => {
  return www_util.msg_post_recv({
    timeout: 2000,
    msg: {
      src: 'hola_ccgi',
      id: 'get_log'
    }
  });
};
var exc_wrapper = (fn, opt) => {
  opt = opt || {};
  return etask({
    cancel: true
  }, [function () {
    if (opt.delay) return etask.sleep(opt.delay);
  }, function () {
    return fn();
  }, function catch$(err) {
    return this.return({
      error: err
    });
  }, function (res) {
    if (opt.cancel_tasks) {
      _.values(opt.cancel_tasks).forEach(function (task) {
        task.return();
      });
    }
    return {
      result: res
    };
  }]);
};
var is_free_vpn = () => {
  return etask([function () {
    return www_util.get_membership({
      cache: true
    });
  }, function (data) {
    return !membership.is_active(data);
  }, function catch$(err) {
    // if fails on first_run - suppose user is free
    var qs = zurl.qs_parse_url(location.href, {
      safe: true
    });
    if (+qs.first_run) return true;
    throw err;
  }]);
};
var handle_no_ext = (rate, opt) => {
  if (opt.download_link) {
    location.href = opt.download_link;
    return;
  }
  var download_browser = zutil.get(hopt, 'www_hola.sitepic_install_browser');
  if (download_browser && window.react_history) {
    var link = iutil.get_exe_link({
      hola_browser: true
    });
    ga.ga_track_download_send('exe', 'browser_from_sitepic', link, null, undefined, {
      hola_browser: true
    });
    iutil.download_file(link);
    if (link.indexOf('-hpa.exe') > -1) {
      return void window.react_history.push('/after_download_br?' + 's=install&browser=1');
    }
    return void window.react_history.push(window.location.pathname + '?flow=hola_browser&step=install');
  }
  www_util.set_cookie('post_install', JSON.stringify({
    redirect_url: 'https://' + rate.link + '/'
  }), {
    min: 15
  });
  var install_opt = {
    install_src: location.pathname.slice(1).replace(/\//g, '_'),
    traget_link: 'https://' + rate.link + '/'
  };
  if (opt.need_exe === false) install_opt = {
    skip: {
      choose_plan: true,
      exe: true
    }
  };
  (opt.start_install || start_install)(install_opt);
  setTimeout(opt.deactivate, 5000);
};
var activate_et, click_count;
export var sitepic_activate = (event, rate, opt = {}) => {
  event.preventDefault();
  event.stopPropagation();
  var is_sitepick_click = opt.is_sitepick_click || (event.currentTarget.className || '').includes('sitepic');
  click_count = click_count ? click_count + 1 : 1;
  var root_url = zurl.get_root_domain(rate.link);
  var info = {
    t: {},
    root_url: root_url,
    click: click_count
  };
  var ext_info = be.ext();
  var enable_err = 0,
    redirect_url,
    t0,
    err_info;
  if (activate_et) activate_et.return();
  etask([function () {
    return ext_info && www_util.check_ext();
  }, function catch$(err) {
    return false;
  }, function (e) {
    if (!e) {
      handle_no_ext(rate, opt);
      return this.return();
    }
  }, function () {
    t0 = Date.now();
  }, function enable_root_url() {
    return is_free_vpn();
  }, function (is_free) {
    var has_trial = rate.has_trial && ext_info && ext_info.ver && version_util.cmp(ext_info.ver, rate.trial_min_ver) >= 0;
    var need_plus = rate.premium_site && !has_trial ? is_free : false;
    if (need_plus) info.redirect_only = true;
    if (is_sitepick_click) {
      if (opt.filter) info.filter = opt.filter;
      var _suf = opt.page == 'welcome' ? '_from_welcome' : '';
      www_util.perr({
        id: 'www_sitepic_click' + _suf,
        info: info
      });
    }
    if (!be.ext()) {
      be.perr({
        id: 'www_sitepic_enable_err_debug',
        info: assign({}, ext_info, info)
      });
    }
    if (need_plus) return {
      rule: {
        link: root_url
      }
    };
    this.spawn(etask([function () {
      var debug_tasks = {
        p1: exc_wrapper(cs_ping, {
          delay: 1000
        }),
        p5: exc_wrapper(cs_ping, {
          delay: 5000
        }),
        c1: exc_wrapper(www_util.check_ext, {
          delay: 1000
        }),
        c5: exc_wrapper(www_util.check_ext, {
          delay: 5000
        }),
        log: exc_wrapper(bext_log)
      };
      var _opt = {
        root_url,
        rule: rate.rule,
        country: opt.country,
        src: 'ui',
        no_reload: true,
        page: opt.page,
        is_onboarding_flow: opt.is_onboarding_flow
      };
      return etask.all(assign({
        enable_rule: exc_wrapper(be.enable_root_url.bind(this, _opt), {
          cancel_tasks: debug_tasks
        })
      }, debug_tasks));
    }, function (res) {
      var enable_rule = res.enable_rule || {};
      if (!enable_rule.error) return enable_rule.result;
      err_info = Object.entries(res).reduce(function (pv, cv) {
        pv[cv[0]] = cv[1].error ? 0 : 1;
        return pv;
      }, {});
      err_info.log = _.get(res, 'log.result.data');
      throw enable_rule.error;
    }]));
    this.spawn(etask.sleep(15000));
    return this.wait_child('any');
  }, function catch$(err) {
    info.t.enable_err = Date.now() - t0;
    enable_err++;
    info.enable_err = enable_err;
    be.perr({
      id: 'www_sitepic_enable_err',
      info: assign(info, {
        err: err.message || '' + err,
        stack: err.stack,
        ext_info: be.can_use_ext(),
        err_info: err_info,
        src: location.pathname
      })
    });
    err_info = undefined;
    if (enable_err > 1) throw new Error('enable_url_failed');
    return this.goto('enable_root_url');
  }, function (res) {
    var e = res.child && res.child.retval || {};
    info.t.enable = Date.now() - t0;
    be.perr({
      id: 'www_sitepic_ok',
      info: info
    });
    redirect_url = rate.url || zurl.add_proto(e.rule && e.rule.name != 'all_browser' && e.rule.link || root_url);
    return etask.sleep(200); // XXX arik: allow perr to be sent
  }, function () {
    location.href = redirect_url;
    return this.wait(20000);
  }, function catch$(err) {
    info.t.err = Date.now() - t0;
    be.perr({
      id: 'www_sitepic_err',
      info: assign(info, {
        err: '' + err,
        path: location.pathname
      })
    });
    location.href = zurl.add_proto(root_url);
  }, function finally$() {
    activate_et = null;
  }]);
};